import '../App.css';
import './Header.css';
import './Games.css';
import './Footer.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const MC = () => {
    return (
        <div className='App'>
      <header>
        <Navbar expand="lg" className='Header-nav'>
          <Container>
            <Navbar.Brand href="#home"><img alt="TheGoldApple logo, with the name written in italics" className="d-inline-block align-top Header-logo" src="https://cdn.tga.fyi/logos/tga_logo_lang_2.png"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='Header-toggler'/>
            <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
                {/* <Nav.Link className='Header-button' href="/vacencies">Vacencies</Nav.Link> */}
                <Nav.Link className='Header-button' href="https://status.tga.fyi">Status</Nav.Link>
                <Nav.Link className='Header-button' href="https://thegoldapple.com/discords">Discord</Nav.Link>
                <Nav.Link className='Header-button' href="https://forum.tga.fyi">Forum</Nav.Link>
                <Nav.Link className='Header-button' href="ts3server://ts.thegoldapple.com">TS</Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Container>
          <Row>
            <Col className='Header-mission-statement'>
              <p>TheGoldApple Minecraft Server</p>
              <p>Need to put a sub para here idk.</p>
            </Col>
          </Row>
        </Container>
        <div className='Header-fade'></div>
      </header>
      <Container className='Content'>
        <p>Add some content here</p>
      </Container>
     
      <Container className='Footer'>
        <Row>
          <Col>
            <p>Designed and created by <a href="https://lawrencetech.uk" className='Footer-credit'><b>Lawrence Tech</b></a>, made in the UK.</p>
            <p>Copyright (c) {(new Date().getFullYear())} TheGoldApple & Lawrence Tech All Rights Reserved.</p>
            <hr />
            <p>Made with 
              <svg width="25px" height="25px" viewBox="-10.5 -9.45 21 18.9" fill="none" xmlns="http://www.w3.org/2000/svg" className="Footer-icon"><circle cx="0" cy="0" r="2" fill="currentColor"></circle><g stroke="currentColor" stroke-width="1" fill="none"><ellipse rx="10" ry="4.5"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(60)"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(120)"></ellipse></g></svg>
            </p>
          </Col>
          <Col className='Footer-Links'>
            <h4>Links</h4>
            <div>
              <ul>
                <li><a className='Footer-Link' href="terms">Terms and Conditions</a></li>
                <li><a className='Footer-Link' href="#about">About Us</a></li>
                <li><a className='Footer-Link' href="#styleguide">Style Guide</a></li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    );
}

export default MC;